import { CognitoUserPool } from 'amazon-cognito-identity-js';
import * as Endpoints from 'constants/endpoints.constant';

const poolData: any = {
  UserPoolId: Endpoints.cognito.UserPoolId,
  ClientId: Endpoints.cognito.ClientId,
};

export const UserPool = new CognitoUserPool(poolData);
